import { render, staticRenderFns } from "./KZGReportList.vue?vue&type=template&id=1ee03e40"
import script from "./KZGReportList.vue?vue&type=script&lang=js"
export * from "./KZGReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports